import MainLayout from './layout';

export default MainLayout;